import { render, staticRenderFns } from "./ExamDescriptionModal.vue?vue&type=template&id=4b8790a9&"
import script from "./ExamDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./ExamDescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./ExamDescriptionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports